module.exports = __webpack_public_path__ + "img/mesa_el_w.813707e5.png";